import { ChangeDetectionStrategy, Component, inject, OnInit, ViewEncapsulation } from "@angular/core";
import { combineLatest, map, Observable } from "rxjs";
import { Router, RouterOutlet } from "@angular/router";
import { AuthenticationService } from "../../services/authentication.service";
import { ApplicationService } from "../../services/application.service";
import { ApplicationStoreService } from "../../stores/application-store.service";
import { GeneralService } from "../../services/general.service";
import { GeneralStoreService } from "../../stores/general-store.service";
import { LiveTimeService } from "../../services/live-time.service";
import { ProfilesService } from "../../services/profiles.service";
import { UserAccountService } from "../../services/user-account.service";
import { UserAccountStoreService } from "../../stores/user-account-store.service";
import { ErrorService } from "../../services/error.service";
import { LoaderComponent } from "../../components/loader/loader.component";
import { TopbarComponent } from "../../components/topbar/topbar.component";
import { AsyncPipe, NgClass, NgIf } from "@angular/common";
import { CookieDisclaimerComponent } from "../../shared/components/cookie-disclaimer/cookie-disclaimer.component";
import { CookieDisclaimerService } from "../../services/cookie-disclaimer.service";

interface AppComponentData {
  darkMode: boolean;
  isLoggedIn: boolean;
}

@Component({
  selector: "app-layout-topbar",
  standalone: true,
  imports: [
    CookieDisclaimerComponent,
    LoaderComponent,
    TopbarComponent,
    NgClass,
    AsyncPipe,
    RouterOutlet,
    NgIf
  ],
  templateUrl: "./layout-topbar.component.html",
  styleUrl: "./layout-topbar.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class LayoutTopbarComponent implements OnInit {

  appComponentData$!: Observable<AppComponentData>;
  public router = inject(Router);

  private authenticationService = inject(AuthenticationService);
  private applicationService = inject(ApplicationService);
  private applicationStore = inject(ApplicationStoreService);
  private generalService = inject(GeneralService);
  private generalStore = inject(GeneralStoreService);
  private liveTimeService = inject(LiveTimeService);
  private profilesService = inject(ProfilesService);
  private userAccountService = inject(UserAccountService);
  private userAccountStore = inject(UserAccountStoreService);
  private errorService = inject(ErrorService);
  cookieDisclaimerService = inject(CookieDisclaimerService);

  constructor() {
  }

  ngOnInit(): void {
    this.appComponentData$ = combineLatest([
      this.generalStore.darkMode$,
      this.userAccountStore.isLoggedIn$,
    ]).pipe(
      map(
        ([
          darkMode,
          isLoggedIn,
        ]) => {
          return {
            darkMode,
            isLoggedIn,
          };
        }
      )
    );
  }

}
